<template>
  <base-table :data="getAlarmSettings">
    <el-table-column
      prop="module"
      :label="$t('sections.alarmSettings.table.module')"
      width="200%"
    />
    <el-table-column :label="$t('sections.alarmSettings.table.alarm')">
      <template slot-scope="props">
        <span>
          {{ populateAlarmParams(props.row.message, props.row.params) }}
        </span>
      </template>
    </el-table-column>
    <el-table-column fixed="right" width="60">
      <template slot-scope="props">
        <div class="d-flex justify-content-center">
          <el-dropdown trigger="click">
            <div class="outline-icon-button">
              <font-awesome-icon icon="fa-regular fa-ellipsis-vertical" />
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <div @click="$emit('openModal', props.row)">
                  {{ $t("sections.alarmSettings.options")[0] }}
                </div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template>
    </el-table-column>
  </base-table>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: 'AlarmSettingsTable',
  computed: {
    ...mapGetters(['getAlarmSettings']),
  },
  methods: {
    populateAlarmParams(rawMsg, params) {
      let msg = rawMsg;
      params.map((param) => {
        const regex = `{${param.label}}`;
        msg = msg.replace(new RegExp(regex, 'g'), param.value);
      });
      return msg;
    },
  },
};
</script>
<style lang="scss" scoped></style>
